const constants = {};

constants.URL = process.env.REACT_APP_API_URL;
constants.BASEURL = constants.URL + "v1";

export default constants;
